"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceBenefitsAtLocation = deviceBenefitsAtLocation;
const dealDevice_1 = require("./dealDevice");
function deviceBenefitsAtLocation(args) {
    const terms = args.deviceTerms || {};
    // A negative index is nonsense from a caller that miscounted; treating it as
    // the first location is the reading that cannot silently withhold an offer.
    const index = Math.max(0, args.locationIndex);
    const out = [];
    for (const [skuId, term] of Object.entries(terms)) {
        // No discount is no benefit. A term can exist purely to say "this device is
        // sold on this deal"; there is nothing to announce about it.
        if (!term?.discount)
            continue;
        if (!(0, dealDevice_1.termAppliesAtLocation)(term, index))
            continue;
        const covers = term.covers === 'first_n' ? 'first_n' : 'each';
        out.push({
            skuId,
            covers,
            ...(covers === 'first_n' && typeof term.coveredUnits === 'number'
                ? { coveredUnits: term.coveredUnits }
                : {}),
            isFree: term.discount.percentOff === 100,
            discount: term.discount,
            takenFrom: term.takenFrom === 'one_time' ? 'one_time' : 'monthly',
        });
    }
    return out;
}
//# sourceMappingURL=dealBenefits.js.map